exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".placeholder[data-v-5030292f] {\n  cursor: pointer;\n}\n.placeholder[data-v-5030292f]:hover {\n  background-color: #f5f5f5 !important;\n}\ninput[type=file][data-v-5030292f] {\n  position: absolute;\n  left: -99999px;\n}", ""]);

// exports
